import { useState } from 'react';
import { Button, Toast } from '@tempmee/react';
import { OutlineExternalLinkIcon } from '@tempmee/react-icons';
import { RemoteConfigUtils } from '~/utils/RemoteConfigUtils';

const TOOLKIT_URL_MISSING_MESSAGE =
  "The Winner's Toolkit isn't available yet. Please check back soon.";

export const WinnersToolkitButton = () => {
  const [showMissingToast, setShowMissingToast] = useState(false);

  return (
    <>
      <Button
        data-cy="bid-toolkit-button"
        startIcon={<OutlineExternalLinkIcon />}
        onClick={() => {
          const toolkitUrl = RemoteConfigUtils.getBestInDentalToolkitUrl();
          if (toolkitUrl) {
            window.open(toolkitUrl, '_blank', 'noopener,noreferrer');
          } else {
            setShowMissingToast(true);
          }
        }}
      >
        Winner&apos;s Toolkit
      </Button>
      <Toast
        open={showMissingToast}
        severity="warning"
        message={TOOLKIT_URL_MISSING_MESSAGE}
        onClose={() => setShowMissingToast(false)}
      />
    </>
  );
};
